// setPrivateStreamAutoPayment.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set private stream auto payment
 * @kind action
 * @param {string} {streamId} - stream id.
 * @param {boolean} {isEnabled} - is private stream auto payment enabled.
 * @return {Promise} Action promise.
 */
const setPrivateStreamAutoPayment =
  ({ streamId, isEnabled = false } = {}) =>
  async dispatch => {
    if (!streamId) return dispatch({ type: '' });
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream', 'autoPayment', streamId],
        data: {
          isEnabled: Boolean(isEnabled),
        },
      },
    });
  };

export default setPrivateStreamAutoPayment;
